module.exports = __webpack_public_path__ + "static/media/hands_17.684d8311.svg";